/**
 * Admin domain route constants
 * Centralized route definitions to avoid hardcoded strings throughout the app
 */

const BASE = '/admin'

export const ADMIN_ROUTES = {
  // Base
  BASE,
  
  // Admin routes
  USERS: `${BASE}/users`,
  BILLING: `${BASE}/billing`,
  TRANSACTIONS: `${BASE}/transactions`,
  F1_SETTINGS: `${BASE}/f1-settings`,
} as const

// Helper to build routes with params (if needed in the future)
export const buildAdminRoute = {
  // Add helpers here as needed, e.g.:
  // userDetail: (userId: string | number) => `${BASE}/users/${userId}`,
}
